module.exports = __webpack_public_path__ + "img/vn.84ca2cbe.svg";